module.exports = __webpack_public_path__ + "static/img/lunbuo2.480e0c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/lunbuo2.jpg
// module id = 8ZvP
// module chunks = 46